import type { DomainMapper } from '../types';

import de from './de';
import fi from './fi';
import gb from './gb';
import no from './no';
import se from './se';
import us from './us';
import dk from './dk';

const previewDomains: DomainMapper[] = [gb, de, us, se, no, fi, dk];

export default previewDomains;
